/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import {
  formName as creditCardInfoFormName,
  billingAddressEnabledFieldName,
} from '../../components/Forms/CreditCardInfoForm';
import { cardSelection as cards } from './CardList';
import disableShippingAddressModal from '../../actions/modals/disableShippingAddressModal';
import disableCreditCardInfoModal from '../../actions/modals/disableCreditCardInfoModal';
import updateUserShippingInfo from '../../actions/userInformation/updateUserShippingInfo';
import updateUserPaymentInfo from '../../actions/userInformation/updateUserPaymentInfo';
import disableCreditCardList from '../../actions/modals/disableCreditCardList';
import enableCreditCardInfoModal from '../../actions/modals/enableCreditCardInfoModal';
import ModalsLayout from './ModalsLayout';
import updateDefaultPayment from '../../actions/userInformation/updateDefaultPayment';
import updatePaymentOptions from '../../actions/userInformation/updatePaymentOptions';
import enableCreditCardList from '../../actions/modals/enableCreditCardList';

const mapUserInfoToPrepopShippingInfo = userInfo => {
  const { firstName, lastName, phoneNumber, emailAddress, shippingAddress } =
    userInfo.customer || {};

  const { street1, street2, city, state, postalCode } = shippingAddress || {};

  return {
    fullName: `${firstName} ${lastName}`,
    street1,
    street2,
    city,
    state,
    postalCode,
    phoneNumber,
    emailAddress,
  };
};

const mapUserInfoToPrepopPaymentInfo = () => {
  return {
    distinctBillingAddress: false,
  };
};

const mapUserInfoToPrepopCardList = (userInfo, selectedCard) => {
  const defaultCard = userInfo.defaultPaymentOption
    ? `${userInfo.defaultPaymentOption.paymentProfileId}`
    : '';
  return selectedCard || defaultCard;
};

const creditCardInfoFormValuesSelector = formValueSelector(
  creditCardInfoFormName
);

const selector = formValueSelector(cards);

const mapStateToProps = ({
  modals: { shippingAddress, creditCardInfo, creditCardList },
  userInfo,
  statesOption,
  ...state
}) => ({
  selectedCard: mapUserInfoToPrepopCardList(
    userInfo,
    selector(state, 'selectedCreditCard')
  ),
  cardsArray: userInfo.paymentOptions || [],
  creditCardListEnabled: creditCardList,
  shippingAddressEnabled: shippingAddress,
  creditCardInfoEnabled: creditCardInfo,
  prepopShippingInfo: mapUserInfoToPrepopShippingInfo(userInfo),
  prepopPaymentInfo: mapUserInfoToPrepopPaymentInfo(),
  states: statesOption,
  distinctBillingAddress: Boolean(
    creditCardInfoFormValuesSelector(state, billingAddressEnabledFieldName)
  ),
  authNetHostedToken: userInfo.authNetHostedToken,
  paymentOptions: userInfo.paymentOptions || [],
  customer: userInfo.customer,
});

const actions = {
  enableCreditCardInfoModal,
  disableShippingAddressModal,
  disableCreditCardInfoModal,
  updateUserShippingInfo,
  updateUserPaymentInfo,
  disableCreditCardList,
  updateDefaultPayment,
  updatePaymentOptions,
  enableCreditCardList,
};

export default connect(mapStateToProps, actions)(ModalsLayout);



// WEBPACK FOOTER //
// ./src/containers/Modals/Modals.js